const SettingConstants = {
  SaveState: {
    IDLE: 'idle',
    SAVING: 'saving',
    SUCCESS: 'success',
    ERROR: 'error',
  },

  PRIVATE_GROUP_SETTING: {
    key: 'NON_BETA_SESSION_SCOPED_PRIVATE_COMMUNITY',
    setting: {
      typeName: 'booleanContent',
      definition: {
        value: true,
      },
    },
  },

  Settings: {
    ALLOW_FORUM: {
      key: 'ALLOW_FORUM',
      type: 'booleanContent',
      defaultTemplate: {
        typeName: 'booleanContent',
        definition: { value: false },
      },
    },
    ALLOW_GROUP_ROSTER: {
      key: 'ALLOW_GROUP_ROSTER',
      type: 'booleanContent',
      defaultTemplate: {
        typeName: 'booleanContent',
        definition: { value: false },
      },
    },
    ALLOW_ZERO_PAYMENT: {
      key: 'ALLOW_ZERO_PAYMENT',
      type: 'booleanContent',
      defaultTemplate: {
        typeName: 'booleanContent',
        definition: { value: false },
      },
    },
    GROUP_PROMOTION_ID: {
      key: 'GROUP_PROMOTION_ID',
      type: 'integerArrayContent',
      defaultTemplate: {
        typeName: 'integerArrayContent',
        definition: { value: [] },
      },
    },
    WHITELIST_EMAIL_DOMAINS: {
      key: 'WHITELIST_EMAIL_DOMAINS',
      type: 'stringArrayContent',
      defaultTemplate: {
        typeName: 'stringArrayContent',
        definition: { value: [] },
      },
    },
    GROUP_SLACK_TEAM_NAME: {
      key: 'GROUP_SLACK_TEAM_NAME',
      type: 'stringContent',
      defaultTemplate: {
        typeName: 'stringContent',
        definition: { value: '' },
      },
    },
    AUTH_TYPE: {
      key: 'AUTH_TYPE',
      type: 'stringContent',
      defaultTemplate: {
        typeName: 'stringContent',
        definition: { value: '' },
      },
    },
    INVITATION_BODY: {
      key: 'INVITATION_BODY',
      type: 'cmlContent',
    },
  },
};

export default SettingConstants;

export const { SaveState, PRIVATE_GROUP_SETTING, Settings } = SettingConstants;
